<template>
  <div>
    <b-field v-if="title">
      <div class="mgl-10px has-text-weight-bold mg-auto">{{ title }} </div>
      <div v-if="!isFromDCF">
        <button class="button is-size-7" @click="clearSelection">
          {{ $t('reseauTempo.panierContent.clearSelection') }}
        </button>
      </div>
    </b-field>
    <div v-if="info" class="has-text-centered has-text-icon-more mgt-20px">{{ info }} </div>
    <div v-for="(produit, index) in panier" :key="index">
      <div class="mgt-10px has-background-background">
        <div class="columns is-vcentered is-marginless shadow is-multiline">
          <div class="panier-imgProduit column is-narrow is-paddingless is-flex">
            <img :src="produit.logo"
                 class="panier-imgProduit-logo" v-if="produit.logo"/>
            <div v-else>
              <div class="panier-imgProduit-reseauTempoLcMairie">
              </div>
            </div>
          </div>
          <div class="column mgl-10px is-paddingless">
            <b-field class="mgb-0">
              <p class="has-text-link is-size-6 ellipsis has-text-weight-bold textPanier">
                {{produit.libelle}}
              </p>
              <b-icon v-if="isFromDCF"
                      icon="bookmark-check"
                      type="is-link" size="is-small" class="mgv-auto">
              </b-icon>
            </b-field>
            <p class="has-text-default is-size-7 ellipsis textPanier">
              {{ $t('reseauTempo.panierContent.datePeriode', {
                dateDebut: formatDate(produit.dateDebut),
                dateFin: formatDate(produit.dateFin),
                semaine: produit.ligneReseau.anneeSemaine.toString().slice(-2),
              })}}
            </p>
            <p class="has-text-icon-more is-size-7 ellipsis textPanier">
              {{returnLibelleProduitLocEtPrix(produit)}}
            </p>
          </div>
          <div class="column is-narrow">
            <a @click="makeDelete(index)" :class="{ 'pointer-events-none' : !canDelete(produit) }">
              <b-icon
                icon="delete-forever"
                :class="{ 'text-access-no-permission': !canDelete(produit) }"
                :type="{ 'is-danger' : canDelete(produit) }">
              </b-icon>
            </a>
          </div>
          <p v-if="typeDCF === TYPE_DEVIS || isPlanning"
            class="column is-12 has-text-default is-size-7 pdb-0
            pdt-0 pdl-10px">
            {{ $t('reseauTempo.panierContent.etatSouhaiteObtenu', {
            etatSouhaite: getEtatSouhaite(produit.etatSouhaite),
            etatObtenu: getEtatObtenu(produit.etatObtenu)
            }) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import formatDate from '@/services/general/formatDate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { CATEGORIE_LOCATION } from '@/configuration/catalogue/produitConf';
import { DELETE_LIGNE_IN_PANIER, SET_PANIER } from '@/store/modules/planningReseauTempo-mutation-type';
import { ETAT_OBTENU, ETAT_SOUHAITE } from '@/configuration/optionBlocage/optionBlocage';
import { TYPE_DEVIS } from '@/configuration/devisConf';

const ProduitReseauTempo = createNamespacedHelpers('planningReseauTempo');

export default {
  props: {
    panier: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    info: {
      type: String,
      required: false,
    },
    isFromDCF: {
      type: Boolean,
      required: true,
    },
    typeDCF: {
      type: String,
    },
  },
  data() {
    return {
      TYPE_DEVIS: TYPE_DEVIS,
      formatDate,
    };
  },
  computed: {
    ...ProduitReseauTempo.mapGetters({
      panierGetter: 'panier',
    }),
    isPlanning() {
      return this.$route.name === 'c.bodac.planning-reseauTempo';
    },
  },
  methods: {
    ...ProduitReseauTempo.mapMutations({
      deleteProduit: DELETE_LIGNE_IN_PANIER,
      setPanier: SET_PANIER,
    }),
    canDelete(ligne) {
      return (!ligne.commandeId) && (!ligne.isAffecteLogistiquement);
    },
    returnLibelleProduitLocEtPrix(produit) {
      let prix = 0;
      let produitLoc = null;
      produit.lignesCommande.forEach((ligne) => {
        if (ligne.typeProduit === CATEGORIE_LOCATION) {
          prix += ligne.totalHt ? ligne.totalHt : 0;
          produitLoc = ligne.libelle;
        }
      });
      if (prix === 0) return produitLoc;
      return `${produitLoc} - ${formatDevise(prix)}`;
    },
    makeDelete(index) {
      this.deleteProduit({ index: index, isFromDCF: this.isFromDCF, isFromSelectScreen: false });
    },
    clearSelection() {
      this.setPanier(this.panierGetter.filter((ligne) => { return ligne.isFromDCF; }));
    },
    getEtatSouhaite(etat) {
      return this.$i18n.t(ETAT_SOUHAITE.find((status) => {
        return status.key === etat;
      }).libelle);
    },
    getEtatObtenu(etat) {
      return this.$i18n.t(ETAT_OBTENU.find((status) => {
        return status.key === etat;
      }).libelle);
    },
  },
};
</script>
